import { render, staticRenderFns } from "./MSelectAccountMenu.vue?vue&type=template&id=0c23300e&"
import script from "./MSelectAccountMenu.vue?vue&type=script&lang=ts&"
export * from "./MSelectAccountMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports